import { useNavigate } from 'react-router-dom';
import { Button, Tooltip } from '@material-ui/core';
import { RiNotification2Fill, RiNotification2Line } from '@remixicon/react';
import { useSidebarOpenState } from '@backstage/core-components';
import { COLORS } from '@internal/backstage-plugin-hm-common';
import { useNotifications } from '../../../hooks';

type NotificationIconProps = {
  withLink?: boolean;
};

type IconProps = {
  count?: number;
};

const Icon = ({ count }: IconProps) => {
  const hasNotifications = !!count;
  const notificationSingularPlural = `Notification${count === 1 ? '' : 's'}`;
  const title = hasNotifications
    ? `${count} ${notificationSingularPlural}`
    : 'No Notifications';

  return (
    <Tooltip
      title={title}
      placement="bottom"
      PopperProps={{
        modifiers: {
          offset: { offset: '0, -6' },
        },
      }}
    >
      {hasNotifications ? (
        <RiNotification2Fill style={{ color: COLORS.NOTIFICATION }} />
      ) : (
        <RiNotification2Line />
      )}
    </Tooltip>
  );
};

export const NotificationIcon = ({ withLink }: NotificationIconProps) => {
  const { count } = useNotifications();
  const { isOpen } = useSidebarOpenState();
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  return withLink ? (
    <Button
      size="small"
      color="primary"
      onClick={() => navigate('/notifications')}
      style={{ textWrap: 'nowrap', minWidth: 'unset' }}
    >
      <Icon count={count} />
    </Button>
  ) : (
    <Icon count={count} />
  );
};
